import React from 'react'

const SvgArrow = props => (
  <svg width={15} height={21} {...props}>
    <path stroke='#FFF' strokeWidth={2} fill='none' d='M1.702 17.421l8.897-7.121-8.897-7.716' />
  </svg>
)

export default SvgArrow
